import { Divider, List, ListItem, Typography } from "@mui/material";
import { Box, Stack } from "@mui/system";
import {
  spacing,
  typography,
  colors,
} from "../../../../../../../../../assets/styles/tokens";

interface PerformanceItemMoreMetricsProps {
  total_income_: string;
  total_income_Percentage: string;
  roi: string;
  net_rev: string;
  pv: string;
  epc: string;
  epc_cpa: string;
  cpa_pv: string;
  cpa_pv_qftd: string;
}

const NegativeBalanceMoreMetrics = ({
  total_income_,
  roi,
  net_rev,
  pv,
  epc,
  epc_cpa,
  cpa_pv,
}: PerformanceItemMoreMetricsProps) => {
  return (
    <>
      <Stack>
        <List sx={{ pb: 0, color: colors.GrayLightMode[900].$value }}>
          <ListItem
            sx={{
              width: "100%",
              display: "block",
              p: spacing.Spacing.sm.$value,
            }}
          >
            <Typography
              sx={{
                fontSize: typography.Size.Text.xs.$value,
                lineHeight: typography.Line_height.text.xs.$value,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Box>CPA INCOME $</Box>
              <Box
                sx={{
                  fontWeight: typography.Font_weight.Semibold.$value,
                  fontSize: typography.Size.Text.sm.$value,
                }}
              >
                {total_income_}
              </Box>
            </Typography>
          </ListItem>
          <Divider />
          <ListItem
            sx={{
              width: "100%",
              display: "block",
              p: spacing.Spacing.sm.$value,
            }}
          >
            <Typography
              sx={{
                fontSize: typography.Size.Text.xs.$value,
                lineHeight: typography.Line_height.text.xs.$value,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Box>RS INCOME $</Box>
              <Box
                sx={{
                  fontWeight: typography.Font_weight.Semibold.$value,
                  fontSize: typography.Size.Text.sm.$value,
                }}
              >
                {roi}
              </Box>
            </Typography>
          </ListItem>
          <Divider />
          <ListItem
            sx={{
              width: "100%",
              display: "block",
              p: spacing.Spacing.sm.$value,
            }}
          >
            <Typography
              sx={{
                fontSize: typography.Size.Text.xs.$value,
                lineHeight: typography.Line_height.text.xs.$value,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Box>CLICK OUT</Box>
              <Box
                sx={{
                  fontWeight: typography.Font_weight.Semibold.$value,
                  fontSize: typography.Size.Text.sm.$value,
                }}
              >
                {net_rev}
              </Box>
            </Typography>
          </ListItem>
          <Divider />

          <ListItem
            sx={{
              width: "100%",
              display: "block",
              p: spacing.Spacing.sm.$value,
            }}
          >
            <Typography
              sx={{
                fontSize: typography.Size.Text.xs.$value,
                lineHeight: typography.Line_height.text.xs.$value,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Box>
                REGS
              </Box>
              <Box
                sx={{
                  fontWeight: typography.Font_weight.Semibold.$value,
                  fontSize: typography.Size.Text.sm.$value,
                }}
              >
                {epc}
              </Box>
            </Typography>
          </ListItem>
          <Divider />
          <ListItem
            sx={{
              width: "100%",
              display: "block",
              p: spacing.Spacing.sm.$value,
            }}
          >
            <Typography
              sx={{
                fontSize: typography.Size.Text.xs.$value,
                lineHeight: typography.Line_height.text.xs.$value,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Box>
                FTD
              </Box>
              <Box
                sx={{
                  fontWeight: typography.Font_weight.Semibold.$value,
                  fontSize: typography.Size.Text.sm.$value,
                }}
              >
                {pv}
              </Box>
            </Typography>
          </ListItem>
          <Divider />
          <ListItem
            sx={{
              width: "100%",
              display: "block",
              p: spacing.Spacing.sm.$value,
            }}
          >
            <Typography
              sx={{
                fontSize: typography.Size.Text.xs.$value,
                lineHeight: typography.Line_height.text.xs.$value,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Box>
                QFTD
                
              </Box>
              <Box
                sx={{
                  fontWeight: typography.Font_weight.Semibold.$value,
                  fontSize: typography.Size.Text.sm.$value,
                }}
              >
                {epc_cpa}
               
              </Box>
            </Typography>
          </ListItem>
          <Divider />
          <ListItem
            sx={{
              width: "100%",
              display: "block",
              p: spacing.Spacing.sm.$value,
            }}
          >
            <Typography
              sx={{
                fontSize: typography.Size.Text.xs.$value,
                lineHeight: typography.Line_height.text.xs.$value,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Box>
                BRAND POLICY PLAN
              </Box>
              <Box
                sx={{
                  fontWeight: typography.Font_weight.Semibold.$value,
                  fontSize: typography.Size.Text.sm.$value,
                }}
              >
                {cpa_pv}
              </Box>
            </Typography>
          </ListItem>
        </List>
      </Stack>
    </>
  );
};

export default NegativeBalanceMoreMetrics;
